import { type FC, Fragment } from 'react';

import { bannersRequest } from 'api/banner';
import Loader from 'components/Loader';
import { useLanguage } from 'store';
import useLayout, { LayoutType } from 'utils/layout';
import { LoadingState } from 'utils/types';
import useRequest from 'utils/useRequest';
import BannerSlider from './BannerSlider';

enum BannerType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

type BannerGroupSlidersProps = {
  groupName: string;
  delay?: number;
};

const BannerGroupSliders: FC<BannerGroupSlidersProps> = ({
  groupName,
  delay,
}) => {
  const layout = useLayout();
  const isMobile = layout === LayoutType.mobile;
  const [language] = useLanguage();

  const { data, loading } = useRequest(
    () =>
      bannersRequest({
        query: {
          lang: language.current.code,
          groupName,
          type: isMobile ? BannerType.MOBILE : BannerType.DESKTOP,
        },
      }),
    [language.current.code, groupName],
  );

  return (
    <>
      {loading === LoadingState.loading && <Loader />}
      {loading === LoadingState.success && (
        <Fragment>
          {data?.map((bannerGroup) => (
            <BannerSlider
              key={bannerGroup.id}
              bannerGroup={bannerGroup}
              delay={delay}
            />
          ))}
        </Fragment>
      )}
    </>
  );
};

export default BannerGroupSliders;
